/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TwitchClipItem } from './TwitchClipItem';
import {
    TwitchClipItemFromJSON,
    TwitchClipItemFromJSONTyped,
    TwitchClipItemToJSON,
    TwitchClipItemToJSONTyped,
} from './TwitchClipItem';

/**
 * 
 * @export
 * @interface GetTwitchClipsResponse
 */
export interface GetTwitchClipsResponse {
    /**
     * 
     * @type {Array<TwitchClipItem>}
     * @memberof GetTwitchClipsResponse
     */
    clips: Array<TwitchClipItem>;
    /**
     * 
     * @type {number}
     * @memberof GetTwitchClipsResponse
     */
    totalClips: number;
}

/**
 * Check if a given object implements the GetTwitchClipsResponse interface.
 */
export function instanceOfGetTwitchClipsResponse(value: object): value is GetTwitchClipsResponse {
    if (!('clips' in value) || value['clips'] === undefined) return false;
    if (!('totalClips' in value) || value['totalClips'] === undefined) return false;
    return true;
}

export function GetTwitchClipsResponseFromJSON(json: any): GetTwitchClipsResponse {
    return GetTwitchClipsResponseFromJSONTyped(json, false);
}

export function GetTwitchClipsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTwitchClipsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clips': ((json['clips'] as Array<any>).map(TwitchClipItemFromJSON)),
        'totalClips': json['totalClips'],
    };
}

export function GetTwitchClipsResponseToJSON(json: any): GetTwitchClipsResponse {
    return GetTwitchClipsResponseToJSONTyped(json, false);
}

export function GetTwitchClipsResponseToJSONTyped(value?: GetTwitchClipsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clips': ((value['clips'] as Array<any>).map(TwitchClipItemToJSON)),
        'totalClips': value['totalClips'],
    };
}

